import { IonIcon, IonSpinner } from '@ionic/react'
import { cloudOffline } from 'ionicons/icons'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../components/actions/Button'
import { AppContext } from '../../contexts/AppContext'
import PublicWrapper from '../../wrappers/publicWrapper/PublicWrapper'

interface Props {}

const NoConnection: React.FC<Props> = () => {
	const { checkNetwork, checkingNetwork } = useContext(AppContext)

	const { t } = useTranslation('pages_noConnection')
	const { t: tCommon } = useTranslation('common')

	return (
		<PublicWrapper id='no-contracts'>
			<IonIcon
				icon={cloudOffline}
				className='text-brand-primary-100-light dark:text-brand-primary-100-dark text-[4.3em] mx-auto'
			/>
			<h1 className='my-4 text-2xl'>{t('oops')}</h1>
			{t('eiYhteytta')}
			{checkingNetwork ? (
				<IonSpinner />
			) : (
				<Button onClick={checkNetwork}>{tCommon('yritaUudelleen')}</Button>
			)}
		</PublicWrapper>
	)
}

export default NoConnection
